export default "__VITE_ASSET__CFPrJ5Vs__"